<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="unduplicatedLearners"
      :loading="isLoading"
      hide-default-footer
      class="elevation-1 mb-10"
      @click:row="onRowClick"
      style="cursor: pointer"
      :options.sync="options"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>

          <div class="text-center mr-5">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <a
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  style="text-decoration: underline"
                  >{{ $t("table.export") }}</a
                >
                <a
                  v-if="$store.state.role != 'centre'"
                  class="pl-3"
                  color="primary"
                  dark
                  style="text-decoration: underline"
                  @click.stop="
                    dialog = true;
                    getLearnerEditHistory();
                  "
                  >View edit history</a
                >
              </template>
              <v-list>
                <!-- Need to include click action to have hover animation -->
                <JsonExcel :data="items" type="csv" :name="title + '.csv'">
                  <v-list-item @click="onExportCsv()">
                    <v-list-item-title>CSV</v-list-item-title>
                  </v-list-item>
                </JsonExcel>
                <v-list-item @click="onExportPdf()">
                  <!-- Need to include click action to have hover animation -->
                  <v-list-item-title>PDF</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-btn tile dark class="mb-2 primary-color" @click="addItem()">
            <v-icon size="20" class="mr-1">mdi-plus</v-icon>
            {{ $t("table.add") }} learner
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <span>{{ $t("table.edit") }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="withdrawItem(item)"
              >mdi-account-off</v-icon
            >
          </template>
          <span>{{ $t("Withdrawn") }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="deleteItem(item)"
              >mdi-delete</v-icon
            >
          </template>
          <span>{{ $t("table.delete") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div class="text-center">
      <v-row>
        <v-col lg="3"></v-col>
        <v-col lg="6">
          <v-pagination
            v-model="page"
            :length="pageLength"
            :total-visible="5"
            color="#6490f1"
          ></v-pagination>
        </v-col>
        <v-col lg="3" class="pt-0">
          <v-select
            :items="[10, 50, 100]"
            label="Rows per page"
            v-model="options.itemsPerPage"
            @change="onItemsPerPageChange()"
          ></v-select>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialog" max-width="700" v-if="editHistories.length > 0">
      <v-card>
        <v-card-title class="headline">Edit History</v-card-title>

        <v-card-text>
          <p v-for="history in editHistories" :key="history._id">
            {{ history.description }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {
    JsonExcel,
  },
  mounted: function () {
    this.abortController = new AbortController();
  },
  props: {
    headers: Array,
    items: Array,
    title: String,
    btnText: String,
    routeTo: String,
    apiRoute: String,
    modalText: String,
    isLoading: Boolean,
    totalCount: Number,
    insights: Object,
    selectedType: String,
  },
  data() {
    return {
      dialog: false,
      abortController: null,
      searchRequest: null,
      show: false,
      search: "",
      pageLength: 0,
      page: 1,
      deleteDialog: false,
      editHistories: [],
      pdfData: null,
      pdfHeader: [
        { text: "Usernmae", style: "tableHeader" },
        { text: "Email", style: "tableHeader" },
        { text: "Role", style: "tableHeader" },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  watch: {
    items: function (newValue) {
      this.items = newValue;
    },
    insights: function (newValue) {
      this.insights = newValue;
    },
    selectedType: function (newValue) {
      switch (newValue) {
        case "complete":
          this.pageLength = Math.ceil(
            this.insights.registered / this.options.itemsPerPage
          );
          break;
        case "in progress":
          this.pageLength = Math.ceil(
            this.insights.inProgress / this.options.itemsPerPage
          );
          break;
        case "pending":
          this.pageLength = Math.ceil(
            this.insights.pending / this.options.itemsPerPage
          );
          break;
        case "cert. due":
          this.pageLength = Math.ceil(
            this.insights.certificationDue / this.options.itemsPerPage
          );
          break;
        case "transferred":
          this.pageLength = Math.ceil(
            this.insights.transferred / this.options.itemsPerPage
          );
          break;
        case "withdrawn":
          this.pageLength = Math.ceil(
            this.insights.withdrawn / this.options.itemsPerPage
          );
          break;
        default:
          this.pageLength = Math.ceil(
            this.insights.registered / this.options.itemsPerPage
          );
          break;
      }
    },
    totalCount: function (newValue) {
      this.pageLength = Math.ceil(newValue / this.options.itemsPerPage);
    },
    options: function (newValue) {
      this.pageLength = Math.ceil(this.totalCount / newValue.itemsPerPage);
    },
    page: async function (newValue) {
      // fix here. it is running 2 times
      if (this.search != "") {
        this.searchLearners(this.search, newValue);
        return;
      }

      this.abortController.abort(); // abort previous fetch request if new request is made
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.page = newValue;
      this.isLoading = true;

      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/learners/batch?page=${newValue}&limit=${this.options.itemsPerPage}&type=${this.selectedType}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
            signal: signal,
          }
        );

        const data = await response.json();

        this.items = data.learners;
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    search: async function (newValue) {
      if (this.searchRequest) {
        clearTimeout(this.searchRequest);
      }

      this.searchRequest = setTimeout(async () => {
        this.page = 1;
        this.searchLearners(newValue);
      }, 250);
    },
  },
  computed: {
    unduplicatedLearners: function () {
      const learnerList = [];

      for (let i = 0; i < this.items.length; i++) {
        let duplicate = false;
        for (let j = 0; j < learnerList.length; j++) {
          if (this.items[i].code == learnerList[j].code) {
            duplicate = true;
            break;
          }
        }

        if (!duplicate) {
          learnerList.push(this.items[i]);
        }
      }

      return learnerList;
    },
  },
  methods: {
    getLearnerEditHistory: async function () {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/learners/editHistory`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();
        this.editHistories = data.editHistories;
      } catch (error) {
        console.log(error);
      }
    },
    searchLearners: async function (searchText, page = 1) {
      try {
        this.isLoading = true;

        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/learners/search?search=${searchText}&page=${page}&limit=${this.options.itemsPerPage}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.items = data.learners;
        this.totalCount = data.totalCount;
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    onRowClick(item) {
      this.$router.push({
        path: "learners/summary",
        query: { id: item._id, code: item.code },
      });
    },
    addItem() {
      this.$router.push({ name: "LearnerDetails" });
    },
    editItem(item) {
      this.$router.push({ path: "learners/details", query: { id: item._id } });
    },
    withdrawItem(item) {
      const confirmDelete = window.confirm(
        `Are you sure to withdraw ${item.firstName}?`
      );
      if (confirmDelete) {
        this.onWithdrawOption(item._id);
      }
    },
    onWithdrawOption: function(id) {
      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/withdraw`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`
        },
        body: JSON.stringify({ id })
      })
        .then(response => response.json())
        .then(data => {
          const feedbackData = {
            title: this.apiRoute,
            message: data.message,
            status: data.status
          };
          this.$emit("optionAdded", feedbackData);
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteItem(item) {
      const confirmDelete = window.confirm(
        `Are you sure to delete ${item.firstName}?`
      );
      if (confirmDelete) {
        this.onDeleteOption(item._id);
      }
    },
    onDeleteOption: function (id) {
      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = {
            title: this.apiRoute,
            message: data.message,
            status: data.status,
          };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onItemsPerPageChange: async function () {
      try {
        this.isLoading = true;

        if (this.search != "") {
          this.searchLearners(this.search);
          return;
        }

        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/learners/batch?page=${this.page}&limit=${this.options.itemsPerPage}&type=${this.selectedType}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.items = data.learners;
        this.totalCount = data.totalCount;
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    onExportCsv: function () {
      console.log("Exporting csv...");
    },
    onExportPdf: function () {
      this.pdfData = this.items.map((item) => [
        item.username,
        item.email,
        item.role,
      ]);

      this.pdfData.unshift(this.pdfHeader);

      var doc = {
        content: [
          { text: `${this.title} List`, style: "header" },
          {
            style: "tableExample",
            table: {
              widths: ["*", "*", "*"],
              headerRows: 1,
              body: this.pdfData,
            },
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
      };
      pdfMake.createPdf(doc).open();
    },
  },
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>